<template>
    <el-card shadow="hover">
        <label slot="header">ip地址输入框 {{ip}}</label>
        <el-divider content-position="left">v-model="ip"</el-divider>
        <j-ip-input style="width: 400px;" v-model="ip" />
        <el-divider content-position="left">只读:value="ip" read-only</el-divider>
        <j-ip-input style="width: 400px;" :value="ip" read-only />
    </el-card>
</template>

<script>
    import JIpInput from "./JIpInput";
    export default {
        components: {
            JIpInput
        },
        data() {
            return {
                ip: '192.168.1.0'
            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>

</style>
